export const readFile = () => true;
